var render = function render(){var _vm=this,_c=_vm._self._c;return _c('memlist-card',{staticStyle:{"width":"100%"},attrs:{"title":"Familjemedlemmar"}},[_c('memlist-static-table',{attrs:{"responsive":"","small":"","fields":_vm.fields,"items":_vm.family}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }